import React from 'react';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import PostcardAppIcon from 'housecall-ui/dist/IconsAndImages/AppIcons/PostcardAppIcon';

import Spacer20 from '../../../Misc/Spacer20.js';

const PostcardStrategy = {
  previewInfo: {
    name: 'Postcards',
    href: '/pro/marketing/postcards',
    iconSvg: <PostcardAppIcon size="xlarge" />,
  },
  headerInfo: {
    name: 'Postcards',
    category: 'Automate sending postcards before + after jobs',
    details: (
      <div>
        Send reminder & thank you postcards to your customers.
        <Spacer20 />
        Direct mail is stil the #1 way that home services companies are advertising. Send a postcard to say thanks after
        a job. Offer a seasonal promotion with an eye-catching design. Follow-up in 3 months to get a rebooking.
      </div>
    ),
    iconSvg: <PostcardAppIcon size="xlarge" />,
  },
  media: {
    wistiaLink: 'https://fast.wistia.net/embed/iframe/ktxgcc4062?autoPlay=false',
  },
  sellingPoints: {},
  planAvailability: {
    title: 'Housecall Pro Plan',
    description: (
      <Grid container spacing={8}>
        <Grid item xs={4}>
          <Typography align="left" variant="body1">
            Basic plan
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography align="right" variant="body1">
            Not Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            Essentials plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            MAX plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
      </Grid>
    ),
  },
  price: {
    hideToggle: true,
    title: 'Housecall Pro Add-on Price',
    description: (
      <div>
        <Grid container spacing={8}>
          <Grid item xs={6}>
            <Typography align="left" variant="body1" color="textSecondary">
              Essentials plan
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography align="right" variant="body1">
              + 86 cents/card
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography align="left" variant="body1" color="textSecondary">
              MAX plan
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography align="right" variant="body1">
              + 86 cents/card
            </Typography>
          </Grid>
        </Grid>
      </div>
    ),
    appActionButton: (
      <Button
        variant="contained"
        color="primary"
        style={{ color: '#ffffff', width: '100%' }}
        href="/pro/marketing/postcards"
      >
        Go to postcard marketing
      </Button>
    ),
  },
  supportContacts: [],
};

export default PostcardStrategy;
